import React from 'react';
import { FieldEditTabProps } from '../../types';
import { OneFragmentOfConstraints } from '../../FieldSerializer/fields/oneFragmentOf';
import { observer } from 'mobx-react';
import RequiredField from '../Constraints/RequiredField';
import { requiredMappedErrors } from '../../../../services/FormUtils/DefinitionFieldMappedErrors';

function MultiCustomFieldConstraints(props: FieldEditTabProps<OneFragmentOfConstraints>) {
    if (props.isArrayChildren) {
        return null;
    }
    return (
        <RequiredField
            relatedTabKey={'validationTab'}
            mappedErrors={requiredMappedErrors}
            onChange={required => props.onChangeConstraint('required', required)}
            value={props.constraints.required}
        />
    );
}

export default observer(MultiCustomFieldConstraints);
